<template>
    <!-- TODO: move the web/mobile to different files -->
    <section>
        <div class="card web container">
            <div class="header">
                <div class="row-wrap header-title">
                    <div class="col" id="title" v-if="!expanded">
                        <slot name="header-title-text" />
                        <LineChart :values="values" :labels="labels" />
                    </div>
                    <div v-if="expanded">
                        <slot name="header-title-text-expanded" />
                    </div>
                    <div class="row expand-button" v-if="!expanded" v-on:click="onExpand">
                        <strong class="primary-text">View Full Report</strong>
                        <img src="@/assets/icons/actions/expand-icon.svg" />
                    </div>
                    <div class="row expand-button" v-if="expanded" v-on:click="onExpand">
                        <p class="minor-text">Close Full Report</p>
                        <img src="@/assets/icons/actions/shrink-icon.svg" />
                    </div>
                </div>
            </div>
            <div class="body" v-if="expanded">
                <div class="line-chart">
                    <LineChart :values="values" :labels="labels" />
                </div>
                <div class="comparison-chart" v-if="quotes !== null">
                    <div class="comparison-item">
                        <div class="row comparison-item-header">
                            <img src="@/assets/icons/other/thumbsup-icon.svg" />
                            <h5>
                                <strong>{{ comparisonLabels[0] }}</strong>
                            </h5>
                        </div>
                        <div class="comparison-item-body">
                            <div
                                class="row comparison-item-quote"
                                v-for="(quote, idx) in quotes[0].slice(0, 3)"
                                :key="`pquote-${idx}`"
                            >
                                <img src="@/assets/icons/other/quote.svg" />
                                <p class="white-text">{{ quote }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="comparison-item">
                        <div class="row comparison-item-header">
                            <img src="@/assets/icons/other/thumbsdown-icon.svg" />
                            <h5>
                                <strong>{{ comparisonLabels[1] }}</strong>
                            </h5>
                        </div>
                        <div class="comparison-item-body">
                            <div
                                class="row comparison-item-quote"
                                v-for="(quote, idx) in quotes[1].slice(0, 3)"
                                :key="`pquote-${idx}`"
                            >
                                <img src="@/assets/icons/other/quote.svg" />
                                <p class="white-text">{{ quote }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mobile container">
            <div class="header" v-if="!expanded">
                <slot name="header-title-text-mobile" />
            </div>
            <div class="body" :style="!expanded ? 'margin-top: 24px' : 'margin-top: 24px'">
                <div class="col" id="mobile-body-section" v-if="expanded">
                    <slot name="header-title-text-expanded-mobile" />
                    <LineChart :values="values" :labels="labels" />
                    <div class="comparison-chart" v-if="quotes !== null">
                        <div class="comparison-item">
                            <div class="row comparison-item-header">
                                <img src="@/assets/icons/other/thumbsup-icon.svg" />
                                <h5>
                                    <strong>{{ comparisonLabels[0] }}</strong>
                                </h5>
                            </div>
                            <div class="comparison-item-body">
                                <div
                                    class="row comparison-item-quote"
                                    v-for="(quote, idx) in quotes[0].slice(0, 3)"
                                    :key="`pquote-${idx}`"
                                >
                                    <img src="@/assets/icons/other/quote.svg" />
                                    <p class="white-text">{{ quote }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="comparison-item">
                            <div class="row comparison-item-header">
                                <img src="@/assets/icons/other/thumbsdown-icon.svg" />
                                <h5>
                                    <strong>{{ comparisonLabels[1] }}</strong>
                                </h5>
                            </div>
                            <div class="comparison-item-body">
                                <div
                                    class="row comparison-item-quote"
                                    v-for="(quote, idx) in quotes[1].slice(0, 3)"
                                    :key="`pquote-${idx}`"
                                >
                                    <img src="@/assets/icons/other/quote.svg" />
                                    <p class="white-text">{{ quote }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" id="mobile-body-header">
                    <span class="divider" />
                    <span class="row" id="expand-mobile-button" @click="onExpandMobile">
                        <p class="minor-text" id="mobile-expand-text" v-if="!expanded">View Full Report</p>
                        <img src="@/assets/icons/actions/expand-gray-icon.svg" v-if="!expanded" />
                        <p class="minor-text" id="mobile-expand-text" v-if="expanded">Close Full Report</p>
                        <img class="closed" src="@/assets/icons/actions/shrink-gray-icon.svg" v-if="expanded" />
                    </span>
                    <span class="divider" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import LineChart from "@/components/other/LineChart";

export default {
    name: "ComparisonCard",
    props: {
        values: Array,
        labels: Array,
        quotes: Array,
        comparisonLabels: Array,
    },
    components: {
        LineChart,
    },
    computed: {},
    methods: {
        onExpand() {
            this.$parent.$emit("expand");
            this.expanded = !this.expanded;
        },
        onExpandMobile() {
            this.expanded = !this.expanded;
        },
    },
    data() {
        return {
            canExpand: this.quotes !== null,
            expanded: false,
        };
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "@/styles/_main.scss";

$left: #8fbedf;
$right: #fe5775;

h3 {
    font-size: 28px;
}

h4 {
    line-height: 28px;
}

p {
    margin: 0;
}

.left-text {
    color: $left;
}

.subheader {
    margin-top: 8px;

    p {
        font-size: 14px;
        padding: 6px 0;
    }
}

.header-title {
    margin-top: -16px;
    justify-content: space-between;
    align-items: center;

    > * {
        margin-top: 16px;
    }

    h3 {
        align-items: flex-end;
    }

    #title {
        width: calc(100% - 200px);
        min-width: 300px;
        max-width: 450px;

        h3 {
            padding-bottom: 15px;
        }
    }
}

.expand-button {
    text-align: end;
    cursor: pointer;

    :first-child {
        padding-right: 8px;
        font-size: 14px;
    }
}

.line-chart {
    padding: 24px 0 36px 0;
}

.web {
    .comparison-item {
        max-height: 280px;
        overflow-y: scroll;
    }
}

.comparison-chart {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    grid-column-gap: 26px;
    grid-row-gap: 24px;

    width: 100%;

    .comparison-item:first-of-type {
        background: $left;
    }

    .comparison-item:nth-of-type(2) {
        background-color: $right;
    }
}

.comparison-item {
    padding: 24px 40px;

    min-width: 220px;

    border-radius: 16px;

    h5 {
        color: white;
    }
}

.comparison-item-header {
    min-width: fit-content;

    :first-child {
        margin-right: 15px;
    }
}

.comparison-item-quote {
    padding: 10px 0;
    align-items: flex-start;

    img {
        filter: brightness(0) invert(1);
    }

    p {
        margin-top: -3px;
        margin-left: 16px;
    }
}

.comparison-item-quote:first-of-type {
    margin-top: 15px;
}

// MOBILE STYLES
.mobile {
    h3 strong {
        font-size: 20px;
    }

    p {
        font-size: 14px;
    }

    .comparison-chart {
        margin-top: 14px;
        margin-left: -24px;
        width: calc(100% + 48px);
    }

    .comparison-item {
        padding: 24px;
        border-radius: 0;
    }
}

#mobile-body-section {
    padding-bottom: 12px;
}

#mobile-body-header {
    align-items: center;
    margin-top: 12px;
}

.divider {
    height: 1px;
    width: 100%;

    background-color: #666666;
    opacity: 0.1;
}

#expand-mobile-button {
    padding: 0 16px;

    p {
        width: max-content;
        padding-right: 8px;
    }
}

#mobile-body-section {
    h4 {
        margin-bottom: 20px;
    }
}
</style>
